import React, { Component } from "react";
import DocViewer, {
  MSDocRenderer,
  PDFRenderer,
  JPGRenderer,BMPRenderer,HTMLRenderer,ImageProxyRenderer,PNGRenderer,TIFFRenderer,TXTRenderer
} from "react-doc-viewer";
class MaterialComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      contentType: null,
      contentId: null,
      materialid: null,
      docs: [
        {
          uri: null,
          fileType: null,
        },
      ],
    };
  }
  componentDidMount() {
    this.setState({
      contentType: this.props.contentType,
      contentId: this.props.contentId,
      materialid: this.props.materialid,
      docs: [
        {
          uri: this.props.materialpath,
          fileType: this.props.materialtype,
        },
      ],
    });
  }
  componentDidUpdate(prevProps) {
    if (
      prevProps.contentType !== this.props.contentType ||
      prevProps.contentId !== this.props.contentId ||
      prevProps.materialid !== this.props.materialid
    ) {
      this.setState({
        contentType: this.props.contentType,
        contentId: this.props.contentId,
        materialid: this.props.materialid,
        docs: [
          {
            uri: this.props.materialpath,
            fileType: this.props.materialtype,
          },
        ],
      });
    }
  }
  render() {
    return (
      <div>
        {/* material Page
        <br />
        Content type=
        {this.state.contentType}
        <br />
        contentId ={this.state.contentId}
        <br /> */}
        {/* materialid ={this.state.materialid}
        materialid ={this.state.docs[0].uri}
        materialid ={this.state.docs[0].fileType} */}
        <DocViewer
          pluginRenderers={[
            MSDocRenderer,
            PDFRenderer,
            HTMLRenderer,
            JPGRenderer,BMPRenderer,ImageProxyRenderer,PNGRenderer,TIFFRenderer,TXTRenderer
          ]}
          config={{
            header: {
             disableHeader: true,
             disableFileName: false,
             retainURLParams: true
            }
           }}
          style={{ width: "auto", height: 450 }}
          documents={this.state.docs}
        />
      </div>
    );
  }
}

export default MaterialComponent;
